module.exports = __webpack_public_path__ + "img/1F1F2-1F1F2.0043d8b8.svg";